import API from '@/services/api'

// Actions
export const FETCH_NOTIFICATIONS = 'fetchNotifications'
export const ADD_NOTIFICATION = 'addNotification'

// Mutations
export const STORE_SET_NOTIFICATIONS = 'storeSetNotifications'
export const STORE_ADD_NOTIFICATION = 'storeAddNotification'

const state = {
	notifications: [],
}

const getters = {
	notifications (state) {
		return state.notifications
	},
}

const actions = {
	[FETCH_NOTIFICATIONS] (context) {
		return new Promise((resolve, reject) => {
			API.query('notifications').then((response) => {
				context.commit(STORE_SET_NOTIFICATIONS, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[ADD_NOTIFICATION] (context, notification) {
		context.commit(STORE_ADD_NOTIFICATION, notification)
	},
}

const mutations = {
	[STORE_SET_NOTIFICATIONS] (state, notifications) {
		state.notifications = notifications
	},
	[STORE_ADD_NOTIFICATION] (state, notification) {
		state.notifications.unshift(notification)
	},
}

export default { state, getters, actions, mutations }